import { render } from "./ic-excel.vue?vue&type=template&id=8b24403c"
import script from "./ic-excel.vue?vue&type=script&lang=js"
export * from "./ic-excel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__